
import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

import Facebook from "./index"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import DataRetriever from "app/data_retriever"

let fbAsyncInitCalled = false

declare global {
  interface Window {
    fbMessengerPlugins: {
      init: () => void,
      callable: Array<(() => void)>,
    } | null,
    fbAsyncInit: (() => void) | null,
  }
}
const fbMessengerPlugins = {
  init: () => {
    WaitObjectByPathPromise("FB")
    .then((FB) => {
      FB.init({
        appId:            "1678638095724206",
        autoLogAppEvents: true,
        xfbml:            true,
        version:          "v3.1",
      })
    })
    .catch(() => {
      // Do nothing, FB can be absent
    })
  },
  callable: [],
}
window.fbMessengerPlugins = window.fbMessengerPlugins || fbMessengerPlugins

const fbAsyncInit = () => {
  // # Duplicated call protection
  if (fbAsyncInitCalled) { return }
  fbAsyncInitCalled = true

  const facebook_app_id = DataRetriever.get("facebook-app-id")
  if (!facebook_app_id) { return }

  // # init the FB JS SDK
  WaitObjectByPathPromise("FB")
  .then((FB) => {
    FB.init({
      // # App ID from the app dashboard
      appId:       facebook_app_id,
      // # Check Facebook Login status
      status:      true,
      // # Look for social plugins on the page
      xfbml:       true,
      // # This is required, DO NOT omit it
      // # @see https://developers.facebook.com/docs/javascript/reference/FB.init/v12.0
      version:     "v12.0",
    })
  })
  .then(() => {
    fbMessengerPlugins.callable.forEach((item: (() => void)) => item())
    fbMessengerPlugins.init()

    Facebook.subscribeListeners.forEach((listener: (() => void)) => listener())
    // # Delete all the listeners after running them
    Facebook.subscribeListeners.length = 0
  })
  .catch(() => {
    // Do nothing, FB can be absent
  })
}
window.fbAsyncInit = fbAsyncInit

function onLoad() {
  requestIdleCallback(() => {
    fbAsyncInit()
  })
}

export default {
  onLoad,
}
